module.exports = __webpack_public_path__ + "static/media/codicon_graph_line.d8a76561.svg";